import React from 'react';
import { List, Skeleton, Typography } from 'antd';
import classNames from 'classnames';
import { useGetComments } from 'api/comments/use-get-comments.ts';
import { useAuthStore } from 'shared/stores';
import { formatDateTime } from 'shared/utils/time/format-date-time.ts';
import type { ECommentEntityName } from 'types/comment.ts';
import styles from './comment-list.module.scss';
import { CommentControl } from './components/comment-control';

const { Text } = Typography;

interface ICommentsListProps {
  entityId: number;
  entityName: ECommentEntityName;
}

export const CommentsList: React.FC<ICommentsListProps> = (props) => {
  const { entityId, entityName } = props;
  const { user } = useAuthStore();
  const { data: comments } = useGetComments({ entityId, entityName });

  return (
    <Skeleton loading={false}>
      <List
        itemLayout='horizontal'
        locale={{ emptyText: <div /> }}
        dataSource={comments?.data || []}
        renderItem={(comment) => {
          const itemClassNames = classNames(styles.item, { [styles.deletedItem]: comment.deletedAt });

          const actions =
            user?.id === comment.userId && !comment.deletedAt ? [<CommentControl comment={comment} />] : [];

          return (
            <List.Item key={comment.id} className={itemClassNames} actions={actions}>
              <List.Item.Meta
                description={
                  <>
                    <div>
                      <Text className={styles.name}>{comment.user.name}</Text>
                      <Text className={styles.date}>{formatDateTime(comment.createdAt)}</Text>
                    </div>
                    <Text className={styles.text}>{comment.text}</Text>
                    {comment.deletedAt ? (
                      <div className={styles.deletedInfo}>deleted {formatDateTime(comment.deletedAt)}</div>
                    ) : null}
                  </>
                }
              />
            </List.Item>
          );
        }}
      />
    </Skeleton>
  );
};
